import { VBtn } from 'vuetify/lib/components/VBtn';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "d-flex flex-column text-center" },
    [
      _c("span", { staticClass: "text-overline mb-5" }, [
        _vm._v(
          _vm._s(_vm.$vuetify.lang.t("$vuetify.worksheet.chooseCustomer"))
        ),
      ]),
      _c(
        "div",
        { staticClass: "d-flex" },
        [
          _c("auto-suggest", {
            staticClass: "flex-grow-1",
            attrs: {
              icon: "mdi-text-box-search-outline",
              showAddButton: false,
              suggestionText: "name",
              suggestionValue: "id",
              "return-object": "",
              label: _vm.$vuetify.lang.t("$vuetify.worksheet.lookupCustomer"),
            },
            on: { search: _vm.lookupCustomer },
            model: {
              value: _vm.customer,
              callback: function ($$v) {
                _vm.customer = $$v
              },
              expression: "customer",
            },
          }),
        ],
        1
      ),
      _vm.customer
        ? _c(
            "div",
            {
              staticClass: "d-flex justify-start flex-column font-weight-bold",
            },
            [
              _c("div", [
                _vm._v("Selected customer: " + _vm._s(_vm.customer.name)),
              ]),
            ]
          )
        : _vm._e(),
      _vm.company
        ? _c(
            "div",
            {
              staticClass: "d-flex justify-start flex-column font-weight-bold",
            },
            [
              _c("div", [
                _vm._v(
                  " " +
                    _vm._s(
                      _vm.$vuetify.lang.t("$vuetify.worksheet.companyName")
                    ) +
                    ": " +
                    _vm._s(_vm.company.name) +
                    " "
                ),
              ]),
            ]
          )
        : _vm._e(),
      _c(
        "div",
        { staticClass: "d-flex justify-center mx-2 my-8" },
        [
          _c(
            VBtn,
            {
              attrs: {
                disabled: _vm.worksheet.status == "USED",
                color: "primary",
              },
              on: {
                click: function ($event) {
                  return _vm.updateWorksheet(_vm.worksheet)
                },
              },
            },
            [_vm._v(_vm._s(_vm.$vuetify.lang.t("$vuetify.base.update")))]
          ),
        ],
        1
      ),
      _c("confirmation-dialog", { ref: "confirm" }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }